module.exports = __webpack_public_path__ + "static/media/vu.f0b65910.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/vu.svg
// module id = 287
// module chunks = 0